import { render, staticRenderFns } from "./TwitterLinkPopover.vue?vue&type=template&id=56ce49c2&"
import script from "./TwitterLinkPopover.vue?vue&type=script&lang=js&"
export * from "./TwitterLinkPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports